import { AntdOptionType } from '@sonar-software/sonar-ts-types';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { getClosestViewArea } from '@lib/popups';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { UserWithMetadata } from '@sonar-software/sonar-core';
import { useUsers } from '@hooks';

import { Form, Select } from 'antd';
import React, { useMemo } from 'react';

function getOptions(users: Array<UserWithMetadata>): Array<AntdOptionType> {
	return users
		.filter((user) => !user.isLocked)
		.map((user) => {
			const { fullName, id } = user;

			return {
				label: fullName,
				value: String(id)
			};
		});
}

export interface TagOwnersInputProps {
	disabled?: boolean;
	name: string;
}

export const TagOwnersInput: React.FC<TagOwnersInputProps> = ({ disabled, name }) => {
	const users = useUsers();

	const options = useMemo(() => getOptions(users), [ users ]);

	return (
		<Form.Item
			className='tag-owners-input'
			name={ name }>
			<Select
				allowClear={ !disabled }
				disabled={ disabled }
				filterOption={ caseInsensitiveContainsFilterOption }
				getPopupContainer={ getClosestViewArea }
				mode='multiple'
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.TAG_OWNERS } />
		</Form.Item>
	);
};
